import type { JSX, ReactNode } from 'react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface EventDetailsActionBarProps {
    actions: ReactNode[];
    closeSlot?: ReactNode;
}

interface EventActionIconButtonProps {
    children: ReactNode;
    label: string;
}

export function EventDetailsActionBar({ actions, closeSlot }: EventDetailsActionBarProps): JSX.Element | null {
    if (!actions.length && !closeSlot) {
        return null;
    }

    return (
        <div className="flex items-center justify-end gap-4">
            {actions.length ? (
                <TooltipProvider delayDuration={0}>
                    <div className="flex flex-wrap justify-end gap-0.5">{actions}</div>
                </TooltipProvider>
            ) : null}
            {actions.length && closeSlot ? <div className="h-5 w-px bg-[#E7DED7]" aria-hidden="true" /> : null}
            {closeSlot}
        </div>
    );
}

export function EventActionIconButton({ children, label }: EventActionIconButtonProps): JSX.Element {
    return (
        <Tooltip>
            <TooltipTrigger asChild>{children}</TooltipTrigger>
            <TooltipContent side="bottom">{label}</TooltipContent>
        </Tooltip>
    );
}
